<div [hidden]="!isLoading && !isCalculatingLinks" class="map-progress-container">
    <ac-progress></ac-progress>
</div>
<div [hidden]="!showMap" class="ac-geo">
    <div #acGeoMap class="ac-geo-map-container"></div>
</div>
